import { PromoCodeForm } from './PromoCodeForm';

export default PromoCodeForm;
